(function(){
    angular.module('tmx-app').controller("TmxConfirmDialogCtrl",TmxConfirmDialogCtrl);

    TmxConfirmDialogCtrl.$inject=['$scope','$mdDialog','tmxUtility','_config'];

    var mdDialog;
    var exists;

    function TmxConfirmDialogCtrl($scope,$mdDialog,tmxUtility,_config){
        exists=tmxUtility.exists;
        $scope.action=_config.action;
        $scope.entity=_config.entity;
        $scope.entityName=_config.entityname;
        $scope.options=rectifyOptions(_config.options);
        $scope.details=_config.details;
        $scope.closeDialogWith=closeDialogWith;

        mdDialog=$mdDialog;
    }
    function closeDialogWith(value){
        mdDialog.hide(value);
    }

    function rectifyOptions(opts){
        var validOptions=[];
        function makeValidOption(opt){
            var validOption=new option(opt)
            validOptions.push(validOption);
        }
        opts.forEach(makeValidOption);
        return validOptions;
    }

    function option(_opt){
        var opt=this;
        opt.label=_opt.label;
        opt.value=_opt.value;
        if(!exists(_opt.class)){
            opt.class="md-primary";		
        }
        else{
            opt.class=_opt.class;
        }
    }


})();